const INLINE = /(\*\*[^*]+\*\*)/g;

const Inline = ({ text }) =>
  text.split(INLINE).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i} className="text-white">{part.slice(2, -2)}</strong> : part,
  );

// Tiny Markdown subset renderer (headings, bullet/numbered lists, paragraphs, **bold**) — no dependency.
export const MiniMarkdown = ({ text }) => {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw) => {
    const line = raw.trimEnd();
    const item = line.match(/^\s*(?:[-*+]|\d+[.)])\s+(.*)$/);
    if (item) {
      if (!list) blocks.push((list = { type: "ul", items: [] }));
      list.items.push(item[1]);
      return;
    }
    list = null;
    const h = line.match(/^#{1,6}\s+(.*)$/);
    if (h) blocks.push({ type: "h", text: h[1] });
    else if (line.trim()) blocks.push({ type: "p", text: line });
  });
  return (
    <div className="space-y-3 break-words text-sm leading-relaxed text-neutral-300 [overflow-wrap:anywhere]">
      {blocks.map((b, i) => {
        if (b.type === "h") return <h4 key={i} className="pt-1 font-display text-xs font-bold uppercase tracking-wider text-[var(--gold-bright)]"><Inline text={b.text} /></h4>;
        if (b.type === "ul") return <ul key={i} className="list-disc space-y-1 ps-5">{b.items.map((it, j) => <li key={j}><Inline text={it} /></li>)}</ul>;
        return <p key={i}><Inline text={b.text} /></p>;
      })}
    </div>
  );
};
